/* sugar:assets/product-subtotals.js@2.0.0 */
/*
 * product-subtotals — paints the savings and subtotal rows from the shared price store.
 *
 * The rows arrive already filled from Liquid, so the first paint is correct before this file
 * runs. All this does is keep them in step when a variant, a quantity, an offer tier or a
 * subscription moves — using the same store the Product Price block reads, so the two can
 * never show different numbers.
 */
(function () {
  function mount(island) {
    if (island.dataset.mounted) return;
    island.dataset.mounted = 'true';

    let config;
    try {
      config = JSON.parse(island.textContent);
    } catch (e) {
      return;
    }

    const root = document.querySelector('[data-_sf="' + config.blockId + '"]');
    if (!root || !window.SugarPricing) return;

    const savingsRow = root.querySelector('[data-savings-row]');

    /*
     * Only the labels that actually contain a token get repainted. A plain "Subtotal" is
     * server-rendered once and never touched again.
     */
    const targets = [];
    root.querySelectorAll('[data-template]').forEach((el) => {
      if (window.SugarPricing.hasTokens(el.dataset.template)) targets.push(el);
    });

    const store = window.SugarPricing.store(config);

    store.subscribe(function (state) {
      /* Nothing saved, nothing to say. */
      if (savingsRow) savingsRow.hidden = state.totalCompare <= state.totalPrice;

      for (let i = 0; i < targets.length; i++) {
        targets[i].innerHTML = window.SugarPricing.fillTokens(
          targets[i].dataset.template,
          state,
          config.format
        );
      }
    });
  }

  function init() {
    document.querySelectorAll('script[data-sugar-subtotals]').forEach(mount);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Section rendering swaps the markup out from under us in the theme editor. */
  document.addEventListener('shopify:section:load', init);
})();
